var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.0002V12.6752C20 9.0752 19.225 6.3252 15.025 6.3252C13 6.3252 11.65 7.4252 11.1 8.4752H11.05V6.6502H7.07495V20.0002H11.225V13.3752C11.225 11.6252 11.55 9.9502 13.7 9.9502C15.825 9.9502 15.85 11.9252 15.85 13.4752V19.9752H20V20.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.324951 6.65039H4.47495V20.0004H0.324951V6.65039Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 0C1.075 0 0 1.075 0 2.4C0 3.725 1.075 4.825 2.4 4.825C3.725 4.825 4.8 3.725 4.8 2.4C4.8 1.075 3.725 0 2.4 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a2ea7db80df1991e47885c7894886254.svg";
export { ForwardRef as ReactComponent };